<template>
  <div class="c_home_card">
    <div class="c_img" :style="{backgroundImage: 'url(' + imgUrl + ')'}"></div>
    <div class="c_content">
      <div class="c_title">{{ titleStr }}</div>
      <div class="c_desc">{{ desc }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['titleStr', 'desc', 'imgUrl'],
  data() {
    return {};
  },
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.c_home_card {
  border-radius: 0.06rem;
  overflow: hidden;
  .c_img {
    height: 1.76rem;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .c_content {
    height: 1.18rem;
    padding: 0.12rem 0.16rem 0.16rem;
    .c_title {
      font-family: AlibabaPuHuiTi-Bold;
      font-size: 0.16rem;
      color: #191919;
      font-weight: 900;
    }
    .c_desc {
      margin-top: 0.04rem;
      height: 0.64rem;
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 0.13rem;
      color: #666666;
      line-height: 0.16rem;
      font-weight: 400;
    }
  }
}
</style>
